import { FileText, BookOpen, Calculator, Wallet, RefreshCcw, Scale } from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HERO_TARIFS = [
  { n: '1 100 F', u: 'HT/salarié/mois', l: '1 à 14 salariés' },
  { n: '900 F', u: 'HT/salarié/mois', l: '15 à 25 salariés' },
  { n: '850 F', u: 'HT/salarié/mois', l: '26 salariés et +' },
  { n: '100 F', u: 'HT/salarié', l: 'Reprise de paie' },
];

export const HERO_CHECKS = [
  'Droit social polynésien', 'CPS · CST · MO natifs',
  '3 modes d\'utilisation', 'Logiciel 100 % PF'
];

export const ARGS = [
  { num: '01', title: 'Spécialiste droit polynésien', desc: "CPS, CST, MO : notre seul et unique métier. Maîtrise totale du droit social local, mise à jour continue des obligations réglementaires propres au territoire." },
  { num: '02', title: 'Tarification transparente', desc: "À l'acte, sans abonnement caché. Vous payez exactement ce qui est produit — rien de plus, jamais. Tarification dégressive et publique applicable dès le 1er mars 2026." },
  { num: '03', title: 'Indépendant de votre comptable', desc: "Liberté totale de choix de votre expert-comptable. Aucun conflit d'intérêt, aucune dépendance. Votre comptable reçoit les OD salaires directement — sans ressaisie." },
  { num: '04', title: 'Support paie dédié', desc: "Un interlocuteur unique qui connaît votre dossier, disponible et réactif sur les situations sensibles — absences prolongées, ruptures, régularisations CPS." },
];

export const INCLUSIONS = [
  { icon: FileText, title: 'Bulletin de paie conforme', desc: "Établi selon le droit social polynésien en vigueur, conforme aux exigences CPS et au code du travail local. Aucun écart réglementaire." },
  { icon: BookOpen, title: 'Déclarations MO + CST', desc: "Mouvement d'Ouvriers et Contribution de Solidarité Territoriale incluses d'office — sans aucun supplément. Jamais." },
  { icon: Calculator, title: 'Livre de paie + OD salaire', desc: "Registre légal mensuel et ordre de décaissement pour votre comptabilité. Zéro ressaisie nécessaire pour votre expert-comptable." },
  { icon: Wallet, title: 'Provisions congés payés', desc: "Calcul et suivi des droits CP intégrés à chaque bulletin pour une gestion sans surprise en fin d'année." },
  { icon: RefreshCcw, title: 'Suivi entrees / sorties', desc: "Gestion des arrivées et départs salariés intégrée au cycle mensuel de paie, sans frais supplémentaires." },
  { icon: Scale, title: 'Veille sociale & conformité', desc: "Mise à jour continue sur l'évolution du droit social polynésien. Votre dossier est toujours conforme." },
];

export const TARIF_CARDS = [
  { palier: '1 – 14 salariés', price: '1 100', badge: null, reduction: null, bg: 'bg-[#0F766E]' },
  { palier: '15 – 25 salariés', price: '900', badge: 'Palier courant', reduction: '-18 % vs palier 1', bg: 'bg-[#0D9488]' },
  { palier: '26 salariés et +', price: '850', badge: null, reduction: '-23 % vs palier 1', bg: 'bg-[#14B8A6]' },
];

export const EXTRAS_FRAIS = [
  { label: 'Reprise de paie existante', val: '100 F HT / salarié', free: false },
  { label: "Création d'une nouvelle paie", val: '0 F HT — Offert', free: true },
  { label: 'DPAE (hors Pack Serenite)', val: '500 F HT / déclaration', free: false },
  { label: 'Audit paie diagnostic', val: 'Gratuit · Sans engagement', free: true },
];

export const PACKS = [
  {
    tier: 'Pack 1', name: 'Essentiel', tagline: "Paie externalisée à l'acte pure",
    abo: null, bgClass: 'bg-[#0F766E]',
    features: [
      { ok: true, bold: true, text: "Bulletins à l'acte au tarif dégressif" },
      { ok: true, text: 'Déclarations MO + CST incluses' },
      { ok: true, text: 'Livre de paie + OD + provisions CP' },
      { ok: true, text: 'Suivi entrées / sorties salariés' },
      { ok: true, text: 'Veille sociale & conformité' },
      { ok: true, text: 'Support paie structuré' },
      { ok: false, text: 'Coffre-fort numérique' },
      { ok: false, text: 'Gestion du temps' },
      { ok: false, text: 'Crédit heures RH' },
    ],
    dpae: '500 F HT / déclaration',
    ideal: 'TPE souhaitant externaliser la paie sans outil additionnel.',
    popular: false
  },
  {
    tier: 'Pack 2', name: 'Confort', tagline: 'Paie + outils numériques',
    abo: '3 500 F HT', bgClass: 'bg-[#0D9488]',
    features: [
      { ok: true, bold: true, text: "Bulletins à l'acte au tarif dégressif" },
      { ok: true, text: 'Déclarations MO + CST incluses' },
      { ok: true, text: 'Livre de paie + OD + provisions CP' },
      { ok: true, text: 'Suivi entrées / sorties salariés' },
      { ok: true, text: 'Veille sociale & conformité' },
      { ok: true, text: 'Support paie structuré' },
      { ok: true, bold: true, text: 'Coffre-fort numérique sécurisé' },
      { ok: false, text: 'Gestion du temps' },
      { ok: false, text: 'Crédit heures RH' },
    ],
    dpae: '500 F HT / déclaration',
    ideal: 'TPE/PME souhaitant sécuriser les documents RH salariés en ligne.',
    popular: true
  },
  {
    tier: 'Pack 3', name: 'Serenite', tagline: 'Gestion RH & paie externalisées',
    abo: '6 500 F HT', bgClass: 'bg-[#14B8A6]',
    features: [
      { ok: true, bold: true, text: "Bulletins à l'acte au tarif dégressif" },
      { ok: true, text: 'Déclarations MO + CST incluses' },
      { ok: true, text: 'Livre de paie + OD + provisions CP' },
      { ok: true, text: 'Suivi entrées / sorties salariés' },
      { ok: true, text: 'Veille sociale & conformité' },
      { ok: true, text: 'Support paie structuré' },
      { ok: true, bold: true, text: 'Coffre-fort numérique sécurisé' },
      { ok: true, bold: true, text: 'Gestion du temps (heures, absences, CP)' },
      { ok: true, bold: true, text: 'Crédit heures accompagnement RH' },
      { ok: true, bold: true, text: 'DPAE illimitées incluses' },
    ],
    dpae: null,
    ideal: "PME souhaitant externaliser l'ensemble de la gestion RH & paie.",
    popular: false
  },
];

export const FAQ_LEFT = [
  { q: "Qu'est-ce que l'externalisation de la paie en Polynésie française ?", a: "L'externalisation consiste à confier la production de vos bulletins, le calcul des charges CPS, CST et MO, et les déclarations obligatoires à un spécialiste local. Le droit social polynésien est distinct du droit métropolitain. Moana Paye est 100 % dédié à ce contexte, sans logiciel à gérer ni paramétrage côté client." },
  { q: "Les déclarations MO et CST sont-elles incluses dans le tarif ?", a: "Oui, sans exception ni surcoût. Le tarif au bulletin (850 F, 900 F ou 1 100 F HT selon effectif) inclut d'office les déclarations de Mouvement d'Ouvriers et la Contribution de Solidarité Territoriale. C'est notre engagement de transparence tarifaire." },
  { q: "Puis-je garder mon expert-comptable actuel ?", a: "Absolument. Moana Paye est indépendant de votre mission comptable. Votre expert-comptable continue de gérer votre comptabilité ; nous gérons votre paie. Vous gardez la liberté totale de choisir vos prestataires séparément — c'est même l'un de nos arguments clés." },
  { q: "Quel est le délai pour démarrer avec Moana Paye ?", a: "Premier bulletin produit dans les 15 jours ouvrés suivant réception de vos données salariés complètes. Frais de reprise : 100 F HT par salarié — la mise en route la plus simple du marché polynésien. La création d'une nouvelle paie est entièrement offerte." },
];

export const FAQ_RIGHT = [
  { q: "Que se passe-t-il si je veux mettre fin au contrat ?", a: "Avec un préavis de 2 mois (ou 3 mois selon ancienneté), vous pouvez dénoncer le contrat à tout moment, y compris avant la fin de la période d'engagement. Aucune indemnité de résiliation n'est appliquée. Vous ne prenez aucun risque à démarrer." },
  { q: "Qu'est-ce que le coffre-fort numérique sécurisé ?", a: "Disponible dans les Packs Confort et Serenite, c'est un espace sécurisé en ligne permettant à chacun de vos salariés d'accéder à ses bulletins et documents RH, avec conservation légale et traçabilité. Aucune gestion technique de votre côté." },
  { q: "Moana Paye intervient-il dans tous les secteurs ?", a: "Oui. Commerce, tourisme, BTP, services, associations, professions libérales — Moana Paye traite tous les secteurs d'activité en Polynésie française." },
  { q: "Quelle différence avec un cabinet comptable ?", a: "Un cabinet comptable traite la paie comme un service annexe. Moana Paye est 100 % dédié à la paie sociale polynésienne. Résultat : tarifs plus bas, réactivité accrue sur les questions RH, et maîtrise approfondie des spécificités locales — CPS, CST, MO." },
];

export const NAV_LINKS = [
  { id: 'pourquoi', label: 'Pourquoi' },
  { id: 'modes', label: 'Votre mode' },
  { id: 'decouvrir', label: 'Le logiciel' },
  { id: 'tarifs', label: 'Tarifs' },
  { id: 'packs', label: 'Packs' },
  { id: 'simulateur', label: 'Simulateur' },
  { id: 'faq', label: 'FAQ' },
];

export const FALLBACK_MOANA = {
  hero: { eyebrow: 'Moana Paye · Papeete, Tahiti', title: 'La paie en Polynésie française, enfin à votre mesure.', subtitle: 'Externalisez tout, collaborez avec nos équipes ou gérez en autonomie — un seul logiciel, trois façons de travailler. Conçu à Papeete, pour la Polynésie.', checks: HERO_CHECKS },
  tarifs_flash: { items: HERO_TARIFS },
  pourquoi: { quote: "La paie ne se joue pas le jour du bulletin : tout se passe avant — heures, absences, variables — et après — documents, questions, situations sensibles.", body: "Moana Paye sécurise l'ensemble du processus, pas seulement le résultat. Votre expert-comptable gère vos comptes. Nous gérons votre paie. Ce sont deux métiers distincts.", signature: 'Groupe AERH Polynésie', args: ARGS },
  faq: { left: FAQ_LEFT, right: FAQ_RIGHT },
  contact: { phone: '+689 87 73 78 15', email: 'contact@groupeaerhpolynesie.com', address: '10 Rue Georges LAGARDE, 98714 Papeete, Tahiti', whatsapp: '+68987737815' },
};

export const fmt = (n) => n.toLocaleString('fr-FR') + ' F';

export const getPalier = (n) => {
  if (n <= 14) return { rate: 1100, label: 'Palier 1 100 F HT/sal.' };
  if (n <= 25) return { rate: 900, label: 'Palier 900 F HT/sal.' };
  return { rate: 850, label: 'Palier 850 F HT/sal.' };
};

export const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
